const AUTH_REDIRECT_TOAST_KEY = 'authRedirectToast'
const AUTH_LOGIN_RELOAD_KEY = 'authLoginReloadPending'

function decodeBase64Url(value) {
  const normalized = value.replace(/-/g, '+').replace(/_/g, '/')
  const padding = normalized.length % 4
  const padded = padding === 0 ? normalized : `${normalized}${'='.repeat(4 - padding)}`

  return atob(padded)
}

function decodeJwtPayload(token) {
  if (typeof token !== 'string') {
    return null
  }

  const [, payload] = token.split('.')
  if (!payload) {
    return null
  }

  try {
    return JSON.parse(decodeBase64Url(payload))
  } catch (error) {
    return null
  }
}

function clearStoredAuthRedirectToast() {
  localStorage.removeItem(AUTH_REDIRECT_TOAST_KEY)
}

function setStoredAuthRedirectToast(message) {
  if (!message) {
    clearStoredAuthRedirectToast()
    return
  }

  localStorage.setItem(AUTH_REDIRECT_TOAST_KEY, message)
}

function consumeStoredAuthRedirectToast() {
  const message = localStorage.getItem(AUTH_REDIRECT_TOAST_KEY)
  clearStoredAuthRedirectToast()

  return message
}

function setPendingLoginReload() {
  localStorage.setItem(AUTH_LOGIN_RELOAD_KEY, '1')
}

function consumePendingLoginReload() {
  const shouldReload = localStorage.getItem(AUTH_LOGIN_RELOAD_KEY) === '1'
  localStorage.removeItem(AUTH_LOGIN_RELOAD_KEY)

  return shouldReload
}

function reloadCurrentPage() {
  window.location.reload()
}

function isJwtExpired(token, nowInSeconds = Math.floor(Date.now() / 1000)) {
  const payload = decodeJwtPayload(token)

  if (!payload || typeof payload.exp !== 'number') {
    return true
  }

  return payload.exp <= nowInSeconds
}

export {
  clearStoredAuthRedirectToast,
  consumePendingLoginReload,
  consumeStoredAuthRedirectToast,
  decodeJwtPayload,
  isJwtExpired,
  reloadCurrentPage,
  setPendingLoginReload,
  setStoredAuthRedirectToast,
}
